import React from "react"
import PropTypes from "prop-types"
import { graphql, StaticQuery } from "gatsby"
import styled from "styled-components"
import NavLink from "./NavLink"

const StyledNavItem = styled.li`
  padding: 1rem 0;

  ${(props) => props.theme.media.tablet_landscape_up`
    padding: 0;
    height: 100%;
    display: flex;
    align-items: center;
  `};
`

const StyledNavLink = styled(NavLink)`
  text-transform: uppercase;
  font-size: 2.1rem;
  font-weight: normal;
  text-align: right;
  margin-top: auto;
  display: inline-block;

  &.active,
  &:hover {
    padding-right: 2rem;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    font-size: 1.6rem;
    padding: 1rem 0;
    margin: 0 1.4rem;
    border-bottom: .5rem solid transparent;
    transition: all ease-out .2s;
    display: flex;

    &.active,
    &:hover {
      padding-right: 0;
    }

    .headroom--scrolled &,
    .headroom--pinned & {
      font-size: 1.6rem;
      color: ${props.theme.colors.primary};

      &.active,
      &:hover {
        padding-right: 0;
        border-bottom: .5rem solid ${props.theme.colors.secondary};
        color: ${props.theme.colors.secondary};
      }
    }
  `};
`

function NavItemComponent({
  url,
  text,
  nav_children,
  children,
  data,
  ...props
}) {
  if (!url) {
    return (
      <StyledNavItem {...props}>{children ? children : text}</StyledNavItem>
    )
  }
  return (
    <StyledNavItem {...props}>
      {children ? children : <StyledNavLink to={url}>{text}</StyledNavLink>}
    </StyledNavItem>
  )
}

const NavItem = (props) => (
  <StaticQuery
    query={graphql`
      {
        prismic {
          allNavigations {
            navs: edges {
              node {
                _meta {
                  id
                }
                navigation_items {
                  navigation_link {
                    ... on PRISMIC_Page {
                      title
                      _meta {
                        id
                        lang
                        uid
                        type
                      }
                    }
                  }
                  navigation_children {
                    _linkType
                    ... on PRISMIC_Navigation {
                      navigtion_title
                      _meta {
                        id
                        lang
                        type
                      }
                    }
                  }
                  navigation_link_text
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <NavItemComponent data={data} {...props} />}
  />
)

export default NavItem

NavItemComponent.defaultProps = {}
NavItemComponent.propTypes = {
  children: PropTypes.node,
}
